import "../design/app.css";
import { getAuth, signInWithPhoneNumber, RecaptchaVerifier} from "firebase/auth";
import firebase from 'firebase/compat/app';
import phone from "../design/phone.png";

function getOtp(){
    const auth = getAuth();
    const phoneNumber = document.getElementById("number").value;
    const appVerifier = window.recaptchaVerifier;

    signInWithPhoneNumber(auth, phoneNumber, appVerifier)
        .then((confirmationResult) => {
        // SMS sent. Prompt user to type the code from the message, then sign the
        // user in with confirmationResult.confirm(code).
        window.confirmationResult = confirmationResult;
        // document.getElementById('sender').hidden = true
        document.getElementById('sender').style.visibility = 'hidden';
        document.getElementById("verifier").classList.remove("hiddenVerification");
        

        }).catch((error) => {
        // Error; SMS not sent
        console.log("Not send " + error)
        // ...
        });
}

function captchaCall(){
    const auth = getAuth();
    window.recaptchaVerifier = new RecaptchaVerifier('recaptcha-container', {}, auth);
    window.recaptchaVerifier.render().then((widgetId) => {
        window.recaptchaWidgetId = widgetId;
      });
    
      getOtp();
}

function sendOTP(){
    const auth = getAuth();
    //Error aa rha ki confirmation result not defined
    const code = document.getElementById("verificationcode").value;
    document.getElementById("verifier").classList.add("hiddenVerification");
    window.confirmationResult.confirm(code).then((result) => {
    // User signed in successfully.
    // const user = result.user;
    auth.signOut();
    var provider = new firebase.auth.GoogleAuthProvider();
        firebase.auth()
        .signInWithPopup(provider)
        .then((result) => {
            var user = result.user;
          }).catch((error) => {
            // Handle Errors here.
            // setError(error.message);
          });
    }).catch((error) => {
    // User couldn't sign in (bad verification code?)
    // ...
        document.getElementById("verifier").classList.remove("hiddenVerification");
        document.getElementById("errorPara").classList.remove("isvisible");

    });
}

function PhoneVerification(){
    return (
        <>
        <div className="verifycontainer">
            <div id="sender">
                <div className="heading">
                    <h1 className="welcome">Welcome to Chatify</h1>
                    <h3 className="welcome-note">This uses a 2-factor Authentication System</h3>
                </div>
                <input type="text" id="number" placeholder={"+91 xxxx-xxxx-xx"}/>
                <div id="recaptcha-container" />
                <input type="button" id="sign-in-button" defaultValue="Send OTP"  onClick={captchaCall}/>
            </div>
            <div id="verifier" className="hiddenVerification">
                <img src={phone} alt="Smartphone Image" className="phoneImg"/>
                <h3 className="verify-note">Please enter the OTP(One Time Password) sent on your given mobile number.</h3>
                <input type="text" id="verificationcode" placeholder="Verification Code" />
                <input type="button" id="verify" defaultValue="Verify" onClick={sendOTP}/>
                <p className="paragraph isvisible" id="errorPara">Wrong OTP. Please Enter again.</p>
            </div>
        </div>
        </>
    )
}

export default PhoneVerification;